import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {DateTime} from 'luxon';

import StandardTooltip from "../../../../../Components/StandardTooltip";
import { signInBooking, signOutBooking } from '../../../Requests/BookingListRequests';
import { showModal } from "../../../../../Redux/GlobalReducer";

const SignInOutButton = (props) => {
    const dispatch = useDispatch();

    const [ isFutureSignIn, setIsFutureSignIn ] = React.useState(false);

    useEffect(() => {
        let now = DateTime.local();
        let bookingDate = DateTime.fromISO(props.booking.start)
        let isFuture = (bookingDate.startOf('day') > now.startOf('day'));
        setIsFutureSignIn(isFuture);
    }, [props.booking.start]);

    const getButtonClasses = (booking) => {
        let classes = (booking.signed_in_at)
            ? 'alert'
            : 'success';

        if (booking._isBusy) {
            classes += ' signing-in';
        }

        if (isFutureSignIn || booking.signed_out_at) {
            classes = 'upcoming disabled';
        }
        return classes;
    }

    const getButtonContent = (booking) => {
        let text = booking.signed_in_at
            ? 'Sign Out'
            : 'Sign In';

        if (isFutureSignIn) {
            text = 'Upcoming';
        }

        if (booking.signed_out_at) {
            text = 'Departed';
        }
        return text;
    }

    const getButtonContentForMobile = (booking) => {
        let text = booking.signed_in_at
            ? 'Out'
            : 'In';

        if (isFutureSignIn) {
            text = '';
        }
        return text;
    }

    const handleButtonClick = (event) => {
        if (props.booking.signed_in_at === null) {
            if (isFutureSignIn) {
                return null;
            }
            if (props.booking.booked_config.searched_at_sign_in_enabled) {
                const dataForModal = {
                    bookingId: props.booking.id,
                    view: props.view,
                    type: props.scope,
                }
                dispatch( showModal('searchedAtSignInModal', dataForModal) );
            } else {
                dispatch( signInBooking(props.view, props.scope, props.booking.id) );
            }
        } else {
            dispatch( signOutBooking(props.view, props.scope, props.booking.id) );
        }
    }

    const getButton = () => {
        return (
            <button
                type="button"
                className={`button width-1 sign-in-button  ${getButtonClasses(props.booking)}`}
                onClick={(e) => handleButtonClick(e)}
            >
                <span className="show-for-medium">
                        {getButtonContent(props.booking)}
                    </span>
                <span className="show-for-small-only">
                        {getButtonContentForMobile(props.booking)}
                    </span>
            </button>
        );
    }

    return (
        <div className="button-group small margin-0">
            {isFutureSignIn &&
                <StandardTooltip
                    title="Bookings can be signed in on the day of their booking"
                >
                    <div style={{cursor: 'not-allowed'}}>
                        {getButton()}
                    </div>
                </StandardTooltip>
            }
            {!isFutureSignIn &&
                getButton()
            }
        </div>
    )
}

export default SignInOutButton;
